/* Red Line design: behaviour for the existing sections below the buy box on
   the default product page. Loaded by sections/main-product.liquid only when
   Red Line is on. Styles: pa-rl-sections.css.
   - Specs: plain headings, no "Category" row, title-cased brand, clearer labels.
   - Buyer quotes: a native scroll-snap row instead of the Flickity carousel.
   - Recommendations: only the same caliber, topped up from search, titled
     "More <caliber>"; the section hides if nothing matches.
   Every step is idempotent and safe to re-run. */
(function () {
  'use strict';

  if (window.__paRlSections) return;
  window.__paRlSections = true;

  var MAX_RECS = 4;
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function text(node) { return node ? (node.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function handle() { return (location.pathname.split('/products/')[1] || '').split(/[/?#]/)[0]; }

  /* ---------- specs + ballistics ---------- */
  function tidySpecs() {
    $$('.ballistics').forEach(function (sec) {
      if (sec.dataset.rlDone) return;
      sec.dataset.rlDone = '1';

      $$('.ballistics-spec', sec).forEach(function (row) {
        var label = text($('.ballistics-spec__label', row));
        var value = $('.ballistics-spec__value', row);
        if (/^category$/i.test(label)) row.classList.add('rl-hide');
        // A bullet type of "Other" (shotshells) says nothing; drop the row.
        if (/^bullet type$/i.test(label) && /^other$/i.test(text(value))) row.classList.add('rl-hide');
        // Gauge slugs: "410.GAUGE" -> ".410 Gauge", "20.BORE" -> "20 Gauge".
        var g = text(value).match(/^\.?(\d+)[.\s-]*(gauge|bore)$/i);
        if (value && g) value.textContent = (g[1] === '410' ? '.410' : g[1]) + ' Gauge';
        // ALL-CAPS brand slugs (MAGTECH) read as shouting; short acronyms (CCI, PMC) stay.
        var v = text(value);
        if (value && /^[A-Z][A-Z .&-]{3,}$/.test(v)) {
          value.textContent = v.toLowerCase().replace(/(^|[\s&-])([a-z])/g, function (m, p, c) { return p + c.toUpperCase(); });
        }
      });

      $$('.ballistics__heading', sec).forEach(function (h) {
        var next = h.nextElementSibling;
        if (next && next.classList.contains('ballistics-specs')) h.textContent = 'Specs';
        else h.textContent = 'Ballistics';
      });

      $$('.ballistics-hero__label', sec).forEach(function (lab) {
        var t = text(lab).toLowerCase();
        if (t === 'velocity') lab.textContent = 'Muzzle velocity';
        else if (t === 'energy') lab.textContent = 'Muzzle energy';
        else if (t === 'weight') lab.textContent = 'Bullet weight';
      });
    });
  }

  /* ---------- buyer quotes: native scroll-snap row ---------- */
  function arrowSvg(dir) {
    var d = dir === 'prev' ? 'M15 4 7 12l8 8' : 'M9 4l8 8-8 8';
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="square"/></svg>';
  }

  function settleQuotes(component, row) {
    var nav = component.flickityNav || (window.Flickity && window.Flickity.data && window.Flickity.data(row));
    if (nav && typeof nav.destroy === 'function') {
      try { nav.destroy(); } catch (e) { /* already gone */ }
    }
    component.flickityNav = null;
    row.removeAttribute('style');
    $$('.testimonial__preview', row).forEach(function (cell) {
      cell.style.removeProperty('position');
      cell.style.removeProperty('left');
      cell.style.removeProperty('transform');
      cell.removeAttribute('aria-hidden');
    });
  }

  function quotes() {
    $$('.testimonials-wrapper--buyer-card testimonials-component').forEach(function (component) {
      var row = $('.testimonial__previews', component);
      if (!row || component.dataset.rlDone) return;
      component.dataset.rlDone = '1';

      // Flickity starts later (when the section nears the viewport). Undo it in
      // the same task, before the browser paints, so the carousel never shows.
      settleQuotes(component, row);
      new MutationObserver(function () {
        if (row.classList.contains('flickity-enabled')) settleQuotes(component, row);
      }).observe(row, { attributes: true, attributeFilter: ['class'] });

      row.setAttribute('tabindex', '0');
      row.setAttribute('role', 'region');
      row.setAttribute('aria-label', 'Buyer quotes, scroll sideways for more');

      var cells = $$('.testimonial__preview', row);
      if (cells.length < 2) return;
      var host = component.closest('.testimonials');
      if (!host || $('.pa-rl-quotes-nav', host)) return;

      var nav = document.createElement('div');
      nav.className = 'pa-rl-quotes-nav';
      var prev = document.createElement('button');
      prev.type = 'button';
      prev.setAttribute('aria-label', 'Previous quotes');
      prev.innerHTML = arrowSvg('prev');
      var next = document.createElement('button');
      next.type = 'button';
      next.setAttribute('aria-label', 'Next quotes');
      next.innerHTML = arrowSvg('next');
      nav.appendChild(prev);
      nav.appendChild(next);
      host.appendChild(nav);

      function step() {
        var first = cells[0];
        var gap = parseFloat(getComputedStyle(row).columnGap) || 0;
        return first ? first.getBoundingClientRect().width + gap : row.clientWidth;
      }
      function sync() {
        var max = row.scrollWidth - row.clientWidth - 2;
        prev.disabled = row.scrollLeft <= 2;
        next.disabled = row.scrollLeft >= max;
      }
      prev.addEventListener('click', function () {
        row.scrollBy({ left: -step(), behavior: REDUCED ? 'auto' : 'smooth' });
      });
      next.addEventListener('click', function () {
        row.scrollBy({ left: step(), behavior: REDUCED ? 'auto' : 'smooth' });
      });
      var raf = 0;
      row.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; sync(); });
      }, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    });
  }

  /* ---------- same-caliber recommendations ---------- */
  function caliberToken() {
    var row = $$('.ballistics-spec').filter(function (r) {
      return /caliber/i.test(text($('.ballistics-spec__label', r)));
    })[0];
    var t = row ? text($('.ballistics-spec__value', row)) : '';
    if (!t) return '';
    var m = t.match(/^(\.?\d+(?:\.\d+)?(?:x\d+)?\s?(?:mm|ACP|Auto|LR|Special|Spl|Mag(?:num)?|Gauge|ga|Win|NATO|S&W|Blackout|BLK|Creedmoor)?)/i);
    return m ? m[1].trim() : t;
  }

  function squash(s) { return (s || '').toLowerCase().replace(/\s+/g, ''); }

  function money(v) {
    var n = Number(v);
    return isFinite(n) ? '$' + n.toFixed(2) : String(v || '');
  }

  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function recCard(p) {
    var url = (p.url || '').split('?')[0];
    var img = (p.featured_image && p.featured_image.url) || p.image || '';
    var art = document.createElement('article');
    art.className = 'product-recommendations__item';
    art.setAttribute('role', 'listitem');

    var media = document.createElement('a');
    media.className = 'product-recommendations__media';
    media.href = url;
    media.tabIndex = -1;
    media.setAttribute('aria-hidden', 'true');
    if (img) {
      var im = document.createElement('img');
      im.className = 'product-recommendations__image';
      im.loading = 'lazy';
      im.alt = '';
      im.width = 360;
      im.height = 360;
      im.src = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=480';
      media.appendChild(im);
    }

    var body = document.createElement('div');
    body.className = 'product-recommendations__body';
    var name = document.createElement('a');
    name.className = 'product-recommendations__name';
    name.href = url;
    name.textContent = p.title || '';
    var price = document.createElement('a');
    price.className = 'product-recommendations__price';
    price.href = url;
    price.tabIndex = -1;
    price.setAttribute('aria-hidden', 'true');
    var varies = p.price_min != null && p.price_max != null && Number(p.price_min) !== Number(p.price_max);
    if (varies) {
      var from = document.createElement('span');
      from.className = 'product-recommendations__from';
      from.textContent = 'From';
      price.appendChild(from);
    }
    var amt = document.createElement('span');
    amt.textContent = money(varies ? p.price_min : p.price);
    price.appendChild(amt);
    body.appendChild(name);
    body.appendChild(price);

    art.appendChild(media);
    art.appendChild(body);
    return art;
  }

  function sameCaliberRecs() {
    var host = $('product-recommendations');
    if (!host) return;
    var grid = $('.product-recommendations__grid', host);
    // Not filled yet (the observer re-runs this), or this grid is already done.
    if (!grid || host._rlGrid === grid) return;
    var token = caliberToken();
    if (!token) return; // no caliber on this product: leave the theme's picks alone
    host._rlGrid = grid;

    var section = host.closest('.shopify-section') || host;
    var key = squash(token);
    var current = handle();
    var matches = function (t) { return squash(t).indexOf(key) !== -1; };
    var kept = 0;
    var seen = {};

    $$('.product-recommendations__item', grid).forEach(function (item) {
      var name = text($('.product-recommendations__name', item));
      var a = $('a[href]', item);
      var href = a ? a.getAttribute('href').split('?')[0] : '';
      if (kept < MAX_RECS && matches(name) && !seen[href]) {
        kept++;
        seen[href] = 1;
      } else {
        item.classList.add('rl-hide');
      }
    });

    var title = $('.title-wrapper .title', host);
    if (title) {
      title.textContent = 'More ' + token;
      var tw = title.closest('.title-wrapper');
      if (tw) tw.classList.remove('title-wrapper--no-heading');
    }

    if (kept >= MAX_RECS) return;
    if (!kept) section.classList.add('rl-hide');

    var q = token.replace(/^\./, '');
    getJSON('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide')
      .then(function (d) {
        var list = (((d || {}).resources || {}).results || {}).products || [];
        list.forEach(function (p) {
          if (kept >= MAX_RECS || !p || p.available === false) return;
          var url = (p.url || '').split('?')[0];
          if (!url || seen[url]) return;
          if (current && url.indexOf('/products/' + current) !== -1) return;
          if (!matches(p.title)) return;
          if (/club|playground|subscribe|subscription|bundle|mystery/i.test(url + ' ' + p.title)) return;
          seen[url] = 1;
          kept++;
          grid.appendChild(recCard(p));
        });
        if (kept) section.classList.remove('rl-hide');
        else section.classList.add('rl-hide');
      });
  }

  /* Shopify can return no recommendations at all (new or thin catalog data).
     Once the section is near the screen and still empty, give it the same
     markup the theme renders so the same-caliber top-up can fill it. */
  function emptyRecsFallback() {
    var host = $('product-recommendations');
    if (!host || !caliberToken() || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      io.disconnect();
      if ($('.product-recommendations__grid', host)) return;
      var pad = document.createElement('div');
      pad.className = 'section--padding';
      var wrap = document.createElement('div');
      wrap.className = 'page-width';
      var tw = document.createElement('div');
      tw.className = 'title-wrapper';
      var h = document.createElement('h2');
      h.className = 'title h1';
      var grid = document.createElement('div');
      grid.className = 'product-recommendations__grid';
      grid.setAttribute('role', 'list');
      tw.appendChild(h);
      wrap.appendChild(tw);
      wrap.appendChild(grid);
      pad.appendChild(wrap);
      host.appendChild(pad);
      sameCaliberRecs();
    }, { rootMargin: '0px 0px 300px 0px' });
    io.observe(host);
  }

  function run() {
    tidySpecs();
    quotes();
    sameCaliberRecs();
  }

  function start() {
    run();
    // Recommendations arrive by fetch and replace the element's innerHTML.
    var recs = $('product-recommendations');
    if (recs) {
      new MutationObserver(sameCaliberRecs).observe(recs, { childList: true });
      emptyRecsFallback();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
